import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import { useVault } from '../context/VaultContext';

export function useHealthSummary() {
  const { activeVaultId } = useVault();

  return useQuery({
    queryKey: ['health', 'summary', activeVaultId],
    queryFn: () => apiClient.getHealthSummary(activeVaultId ?? undefined),
  });
}
